import { useEffect, useMemo, useState } from 'react';
import { Field } from '../modal/ModalCustomTableFields/types';
import React from 'react';
import { Button } from 'react-covideo-common';
import { IoMdOptions } from 'react-icons/io';
import { ModalCustomTableFields } from '../modal';
import { useTranslation } from 'react-i18next';
import { useCDK } from 'lib/hooks/useCdk';
import {
  initializeReportsFromStorage,
  saveReportsToStorage,
} from '../modal/ModalCustomTableFields/util';

export function ButtonWithTableFieldsModal({
  allFields,
  defaultReports,
  onUpdateClick,
  maxFieldConfig,
  storageKey,
  setReports,
  reports,
  staticFields = [],
}: {
  allFields: Field[];
  staticFields?: Field[];
  defaultReports: Field[];
  onUpdateClick: (selected: Field[]) => void;
  setReports: React.Dispatch<React.SetStateAction<Field[]>>;
  reports: Field[];
  maxFieldConfig?: {
    count: number;
    hideText?: boolean;
  };
  storageKey: string;
}) {
  const { primaryToSecondary } = useCDK();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);
  // init from LS
  useEffect(() => {
    const selected = initializeReportsFromStorage({
      allReports: [...staticFields, ...allFields],
      storageKey: `CovideoTableFields${storageKey}`,
      defaultReports: [...staticFields, ...defaultReports],
    });
    setReports(selected);
  }, [i18n.language]);

  const onSaveCustomTableFields = (fields: Field[]) => {
    const fieldsToSave = fields.length ? fields : defaultReports;
    onUpdateClick([...staticFields, ...fieldsToSave]);
    saveReportsToStorage({
      storageKey: `CovideoTableFields${storageKey}`,
      reports: [...staticFields, ...fieldsToSave],
    });
    closeModal();
  };

  // CustomTableFields excluding static fields to ensure only dynamic fields are processed.
  const filteredSelectedFields = useMemo(
    () =>
      reports.filter(
        field =>
          !staticFields.some(staticField => staticField.value === field.value)
      ),
    [reports]
  );

  return (
    <>
      <Button
        icon={<IoMdOptions size={20} />}
        onClick={openModal}
        variant={primaryToSecondary}
      />
      {open && (
        <ModalCustomTableFields
          title={t('Change Columns')}
          allFields={allFields}
          initialFields={
            !!reports.length ? filteredSelectedFields : defaultReports
          }
          onClose={closeModal}
          maxFieldConfig={maxFieldConfig}
          actionButtons={[
            {
              onClick: closeModal,
              text: t('Back'),
              variant: 'secondary',
            },
            {
              onClick: onSaveCustomTableFields,
              text: t('Update'),
            },
          ]}
        />
      )}
    </>
  );
}
